import React from "react";

const EditProfile = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="white" />
      <g clipPath="url(#clip0_744_9431)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1958 8.181L6.90967 13.4672L6.18867 16.1563L5.71442 17.9279C5.70125 17.9774 5.70131 18.0295 5.71461 18.079C5.72791 18.1284 5.75397 18.1735 5.79019 18.2097C5.8264 18.246 5.8715 18.272 5.92096 18.2853C5.97042 18.2986 6.02251 18.2987 6.072 18.2855L7.84242 17.8107L10.5322 17.0897H10.5328L15.8189 11.8035L12.1964 8.181H12.1958ZM18.0047 8.7935L15.207 5.99525C15.1529 5.94103 15.0886 5.89802 15.0178 5.86867C14.9471 5.83932 14.8712 5.82422 14.7946 5.82422C14.718 5.82422 14.6421 5.83932 14.5713 5.86867C14.5006 5.89802 14.4363 5.94103 14.3822 5.99525L12.9384 7.43842L16.5615 11.0615L18.0047 9.61775C18.0589 9.56363 18.1019 9.49934 18.1313 9.42857C18.1606 9.35781 18.1757 9.28195 18.1757 9.20534C18.1757 9.12872 18.1606 9.05287 18.1313 8.9821C18.1019 8.91133 18.0589 8.84705 18.0047 8.79292"
          fill="#BEC2C9"
        />
      </g>
      <defs>
        <clipPath id="clip0_744_9431">
          <rect width="14" height="14" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EditProfile;
